<template>
	<div class="ResetPassword_view">
		<ResetPassword_Form />
	</div>
</template>

<script>
import ResetPassword_Form from '../../components/organisms/forms/ResetPassword_Form'

export default {
	name: 'ResetPassword_view',
	components: {
		ResetPassword_Form
	},
	methods: {}
}
</script>

<style scoped lang="scss">
.ResetPassword_view {
	//min-height: calc(100vh - 100px);
	min-height: 100vh;
	background: linear-gradient(
		0deg,
		rgba(97, 107, 129, 1) 0%,
		rgba(179, 188, 208, 1) 100%
	);
	text-align: center;
	padding-top: 40px;

	@include for-tablet-portrait-up {
		padding-top: 100px;
		//min-height: calc(100vh - 160px)
	}

	> * {
		margin-left: auto;
		margin-right: auto;
	}
}
</style>
